import { motion, useReducedMotion } from "framer-motion";
import { Parallax, ChapterLabel, EASE } from "./Motion";
import { EDITORIAL } from "../../data/content";

export const Ch6Privacy = () => {
  const reduce = useReducedMotion();
  return (
    <section id="chapter-6" className="relative w-full overflow-hidden bg-charcoal">
      <Parallax src={EDITORIAL.privacy} alt="A dim, warm-lit interior at dusk" className="absolute inset-0 h-full w-full" strength={7} imgClass="opacity-70" />
      <div className="absolute inset-0 bg-charcoal/60" />

      <div className="relative z-10 min-h-[92svh] mx-auto max-w-[1400px] px-6 sm:px-10 py-24 flex flex-col items-center justify-center text-center">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
          <ChapterLabel index="Chapter Six" title="Privacy" tone="cream" />
        </motion.div>
        <motion.h2
          initial={reduce ? { opacity: 0 } : { opacity: 0, y: 30 }}
          animate={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
          transition={{ duration: 1.3, ease: EASE, delay: 0.2 }}
          className="serif-display mt-8 max-w-4xl text-[2rem] sm:text-[3.3rem] lg:text-[4.1rem] font-light text-cream"
        >
          Your story belongs to you.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1.1, delay: 0.6 }}
          className="mt-8 text-base sm:text-lg font-normal sm:font-light tracking-wide text-cream/70"
        >
          Anonymous by design. Never sold. Always yours.
        </motion.p>
      </div>
    </section>
  );
};
